import * as React from "react";
import { forwardRef } from "react";
const CheckIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 10 10",
  fill: "currentColor",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.68312 1.2697c.40338.37727.42448 1.01009.04719 1.41342l-5.61233 6c-.18926.20234-.45399.31709-.73106.31688-.27706-.00021-.54162-.11535-.73058-.31798L.26867 6.1217c-.376669-.4039-.3545902-1.03668.049314-1.41335.403905-.37667 1.036686-.35459 1.413356.04932l1.65744 1.77728L8.2697 1.31688C8.64697.913547 9.27979.89242 9.68312 1.2697",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(CheckIcon);
export { ForwardRef as CheckIcon };